import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class AppSequenceCounterQueryCriteriaClass extends BaseCriteriaModel {
  txnType?: Optional<string> = Optional.empty();
  docType?: Optional<string> = Optional.empty();
  logic?: Optional<string> = Optional.empty();
  module_name?: Optional<string> = Optional.empty();
  compositeGuid01?: Optional<string> = Optional.empty();
  compositeGuid02?: Optional<string> = Optional.empty();
  compositeGuid03?: Optional<string> = Optional.empty();
  compositeGuid04?: Optional<string> = Optional.empty();
  compositeGuid05?: Optional<string> = Optional.empty();
  compositeGuid06?: Optional<string> = Optional.empty();
  compositeGuid07?: Optional<string> = Optional.empty();
  compositeGuid08?: Optional<string> = Optional.empty();
  compositeGuid09?: Optional<string> = Optional.empty();
  compositeGuid10?: Optional<string> = Optional.empty();
}

export class AppSequenceCounterCriteriaModelQuery {
  query = '';

  constructor(appSequenceCounterCriteriaModel: AppSequenceCounterQueryCriteriaClass) {

    if (!appSequenceCounterCriteriaModel) {
      return;
    }

    this.query += appSequenceCounterCriteriaModel.txnType.filter(x => x !== '').map(x => '&txnType=' + x).orElse('');
    this.query += appSequenceCounterCriteriaModel.docType.filter(x => x !== '').map(x => '&docType=' + x).orElse('');
    this.query += appSequenceCounterCriteriaModel.logic.filter(x => x !== '').map(x => '&logic=' + x).orElse('');
    this.query += appSequenceCounterCriteriaModel.module_name.filter(x => x !== '').map(x => '&module_name=' + x).orElse('');
    this.query += appSequenceCounterCriteriaModel.compositeGuid01.filter(x => x !== '').map(x => '&compositeGuid01=' + x).orElse('');
    this.query += appSequenceCounterCriteriaModel.compositeGuid02.filter(x => x !== '').map(x => '&compositeGuid02=' + x).orElse('');
    this.query += appSequenceCounterCriteriaModel.compositeGuid03.filter(x => x !== '').map(x => '&compositeGuid02=' + x).orElse('');
    this.query += appSequenceCounterCriteriaModel.compositeGuid04.filter(x => x !== '').map(x => '&compositeGuid04=' + x).orElse('');
    this.query += appSequenceCounterCriteriaModel.compositeGuid05.filter(x => x !== '').map(x => '&compositeGuid05=' + x).orElse('');
    this.query += appSequenceCounterCriteriaModel.compositeGuid06.filter(x => x !== '').map(x => '&compositeGuid06=' + x).orElse('');
    this.query += appSequenceCounterCriteriaModel.compositeGuid07.filter(x => x !== '').map(x => '&compositeGuid07=' + x).orElse('');
    this.query += appSequenceCounterCriteriaModel.compositeGuid08.filter(x => x !== '').map(x => '&compositeGuid08=' + x).orElse('');
    this.query += appSequenceCounterCriteriaModel.compositeGuid09.filter(x => x !== '').map(x => '&compositeGuid09=' + x).orElse('');
    this.query += appSequenceCounterCriteriaModel.compositeGuid10.filter(x => x !== '').map(x => '&compositeGuid10=' + x).orElse('');

    this.query += '&status=' + appSequenceCounterCriteriaModel.status;
    this.query += '&orderBy=' + appSequenceCounterCriteriaModel.orderBy;
    this.query += '&order=' + appSequenceCounterCriteriaModel.order;
    this.query += '&offset=' + appSequenceCounterCriteriaModel.offset + '&limit=' + appSequenceCounterCriteriaModel.limit;
  }
}
